// extracted by mini-css-extract-plugin
export default {"termsOfUse":"TermsOfUse_termsOfUse__wQ4P9","privacyPoliceWrap":"TermsOfUse_privacyPoliceWrap__UI6b9","privacyPolice":"TermsOfUse_privacyPolice__bHR+r"};